import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  NEWS_CREATE, COUNTRY_LIST_DROPDOWN, STATE_LIST_DROPDOWN, REGION_LIST_DROPDOWN, CHAPTER_LIST_DROPDOWN
} from "../../routes/routes";
import { toast } from "react-toastify";
import defaultIcon from "../../assets/images/defaultimage.png";
import { NEWS_CREATED } from "../../constant/constant";
import { ValidationMessage, hasRole } from "../../components/Utils";
import Select from "react-select";
import "flatpickr/dist/themes/material_red.css";
import { FullPageLoader } from '../../components/common/Loader'; // Import the loader component
import { Image } from "react-bootstrap";
import ModalImage from "react-modal-image";
import ImageCropModal, {
  NEWS_IMAGE_MAX_BYTES,
} from "../../components/common/ImageCropModal";

const NewsCreate = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filter, setFilter] = useState([]);
  const [cropSrc, setCropSrc] = useState(null);
  const [cropFileMeta, setCropFileMeta] = useState({ name: "", type: "" });
  const [showCropModal, setShowCropModal] = useState(false);

  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);
  const imageInputRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const handleImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > NEWS_IMAGE_MAX_BYTES) {
      toast.error("Image must be 5MB or less");
      e.target.value = "";
      return;
    }

    if (cropSrc) {
      URL.revokeObjectURL(cropSrc);
    }
    const src = URL.createObjectURL(file);
    setCropSrc(src);
    setCropFileMeta({ name: file.name, type: file.type });
    setShowCropModal(true);
  };

  const handleCropCancel = () => {
    setShowCropModal(false);
    if (cropSrc) {
      URL.revokeObjectURL(cropSrc);
    }
    setCropSrc(null);
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
  };

  const handleCropConfirm = (file, previewUrl) => {
    setShowCropModal(false);
    if (cropSrc) {
      URL.revokeObjectURL(cropSrc);
    }
    setCropSrc(null);
    setForm((prev) => ({
      ...prev,
      image_path: file,
      cardImage: previewUrl,
    }));
    if (imageInputRef.current) {
      imageInputRef.current.value = "";
    }
  };

  /*
   * @param {*} input
   * @param {*} callback
  */

  const auth_user = JSON.parse(localStorage.getItem("user"));

  const submit = async (e) => {
    setLoading(true);
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .post(NEWS_CREATE, requestBody, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 && res.data.success) {
          toast.success(NEWS_CREATED);
          navigate("/news");
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        }
      })
      .finally(() => {
        setLoading(false);
        setBtnDisabled(false);
      });
  };

  useEffect(() => {

    if (hasRole([6])) {
      setForm({ ...form, country_id: auth_user?.country_id })
    }

    if (hasRole([7])) {
      setForm({ ...form, country_id: auth_user?.country_id, state_id: auth_user?.state_id })
    }

    if (hasRole([2])) {
      setForm({ ...form, country_id: auth_user?.country_id, state_id: auth_user?.state_id, region_id: auth_user?.region_id })
    }

    if (hasRole([3])) {
      setForm({ ...form, country_id: auth_user?.country_id, state_id: auth_user?.state_id, region_id: auth_user?.region_id, chapter_id: auth_user?.chapter_id })
    }

    const fetchData = async () => {
      try {
        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter
          }
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [filter]);

  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <h5 className="page-title">News Feed</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/news"}>
                    <span>News Feed List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Create News Feed</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/news"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Create News</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">

                    {hasRole([1]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="country_id" className="form-label">
                            Country
                          </label>
                          <Select
                            name="country_id"
                            isClearable
                            options={countryOptions}
                            placeholder="All Countries"
                            onChange={(selected) => {
                              handleStateClear();
                              setForm({ ...form, country_id: Number(selected?.value), state_id: null, region_id: null, chapter_id: null });
                              setFilter({ ...filter, country_id: selected?.value, state_id: null, region_id: null, chapter_id: null })
                            }}
                          />
                          <ValidationMessage error={errors} name="country_id" />
                        </div>
                      </div>
                    }

                    {hasRole([1, 6]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="state_id" className="form-label">
                            State
                          </label>
                          <Select
                            ref={selectStateRef}
                            name="state_id"
                            isClearable
                            placeholder="All States"
                            options={stateOptions}
                            onChange={(selected) => {
                              handleRegionClear();
                              setForm({ ...form, state_id: Number(selected?.value), region_id: null, chapter_id: null });
                              setFilter({ ...filter, state_id: selected?.value, region_id: null, chapter_id: null })
                            }}
                          />
                          <ValidationMessage error={errors} name="state_id" />
                        </div>
                      </div>
                    }

                    {hasRole([1, 6, 7]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label htmlFor="region_id" className="form-label">
                            Region
                          </label>
                          <Select
                            isClearable
                            ref={selectRegionRef}
                            options={regionOptions}
                            placeholder="All Regions"
                            onChange={(selected) => {
                              handleChapterClear();
                              setForm({ ...form, region_id: Number(selected?.value), chapter_id: null });
                              setFilter({ ...filter, region_id: selected?.value, chapter_id: null })
                            }}
                          />
                          <ValidationMessage error={errors} name="region_id" />
                        </div>
                      </div>
                    }

                    {hasRole([1, 6, 7, 2]) &&
                      <div className="col-6">
                        <div className="mb-3">
                          <label className="form-label" htmlFor="chapter_id">
                            Chapter
                          </label>
                          <Select
                            isClearable
                            ref={selectChapterRef}
                            options={chapterOptions}
                            placeholder="All Chapters"
                            onChange={(selected) => {
                              setForm({ ...form, chapter_id: selected?.value });
                            }}
                          />
                          <ValidationMessage error={errors} name="chapter_id" />
                        </div>
                      </div>
                    }


                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="title"
                        >
                          Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="title"
                          placeholder="Title"
                          onChange={(e) =>
                            setForm({ ...form, title: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="title" />
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="d-flex justify-content-between">
                        <label htmlFor="image_path" className="form-label">
                          News Image (1080 x 1350)
                          <span className="text-danger">*</span>
                        </label>
                        <div className="d-flex gap-3 image-info">
                          <div>
                            <label>Max :</label>
                            <span>5MB</span>
                          </div>
                        </div>
                      </div>
                      <input
                        ref={imageInputRef}
                        type="file"
                        className="form-control"
                        accept="image/jpeg, image/png, image/jpg"
                        onChange={handleImageSelect}
                      />
                      <div className="m-3">
                        {form?.cardImage ? (
                          <span className="d-inline-block" style={{ width: 108 }}>
                            <ModalImage
                              small={form.cardImage}
                              large={form.cardImage}
                              alt="News image preview"
                              hideDownload={true}
                              className="img-fluid"
                            />
                          </span>
                        ) : (
                          <Image
                            width={108}
                            height={135}
                            src={defaultIcon}
                            style={{ objectFit: "cover" }}
                          />
                        )}
                      </div>
                      <ValidationMessage error={errors} name="image_path" />
                    </div>


                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="description"
                        >
                          Description <span className="text-danger">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control hide-arrow"
                          id="description"
                          rows="6"
                          placeholder="Description"
                          onChange={(e) =>
                            setForm({ ...form, description: e.target.value })
                          }
                        />
                        <ValidationMessage error={errors} name="description" />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="video_path"
                        >
                          News Url (Youtube Link)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="video_path"
                          placeholder="Video Url"
                          onChange={(e) =>
                            setForm({ ...form, video_path: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, video_path: e.target.value })
                          }
                          defaultValue={form?.video_path}
                        />
                        <ValidationMessage error={errors} name="video_path" />
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/news"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        &nbsp; Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ImageCropModal
        show={showCropModal}
        imageSrc={cropSrc}
        fileName={cropFileMeta.name}
        mimeType={cropFileMeta.type}
        onCancel={handleCropCancel}
        onConfirm={handleCropConfirm}
      />
    </div>
  );
};

export default NewsCreate;
